import { createModel } from '../model/index.js';
import model from './index.model.js';
const Model = createModel(model);
export default class Context extends Model {
}
